/** Pure helpers for facilitator lobby seat state (used by Lobby and tests). */

export function findFacilitatorEntry(facilitators, email) {
  if (!email || !Array.isArray(facilitators)) return null
  const normalized = email.trim().toLowerCase()
  return facilitators.find((f) => f.email?.trim().toLowerCase() === normalized) ?? null
}

export function getFacilitatorSeatTeamId(facilitatorEntry) {
  if (!facilitatorEntry) return null
  return facilitatorEntry.player_team_id ?? facilitatorEntry.current_team_id ?? null
}

export function facilitatorActsAsSeatedPlayer(facilitatorEntry) {
  if (!facilitatorEntry) return false
  return Boolean(getFacilitatorSeatTeamId(facilitatorEntry) || facilitatorEntry.is_player)
}
